import React from 'react'
import { connect } from "react-redux";
import { SetDepositNextStep, SetDepositOldBank } from '$Deposits/store/actions/DepositAction'
import { SetDepositPayments_BQR } from '$Deposits/store/actions/DepositPost'
import { BQR_Submit } from '$Deposits/store/actions/DepositEvent'
import NextStep from './NextStep'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import TipsView from '../Components/TipsView'
import NameInput from '../Components/NameInput'
import SubmitBtn from '../Components/SubmitBtn'
import AvailableMethods from '../Components/AvailableMethods'
import UserBankSelect from '../Components/UserBankSelect'
import BQRCon from '$Deposits/Components/BQR'
import BankNone from '../Components/BankNone'


class BQR extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        return (
            <div className='methodsActive BQR'>
                <BQRCon
                    TipsView={TipsView}
                    BankNone={BankNone}
                    AvailableMethods={AvailableMethods}
                    NameInput={NameInput}
                    UserBankSelect={UserBankSelect}
                    MoneyInput={MoneyInput}
                    SubmitBtn={SubmitBtn}
                    NextStep={NextStep}
                    SuccessPage={SuccessPage}
                />
            </div>
        );
    }
}

export default BQR



